// Nikura Custom Code - Cart (basket pop-out) events - Start
// Colleagues' tracking sheet 12fQI2GIr--PPuhdRlWcwHGRcE0g8g4mwC1ctyWbuf5U rows 29-33 (columns E-H).
// Pushes one flat dataLayer event per interaction (the house 'NK dL' field style); GTM custom-event
// triggers map each event to a GA4 tag.
//   cart_close            - cart X next to 'YOUR BASKET'
//   cart_remove_item      - a line leaves the basket: bin icon, minus down to 0 or a typed 0
//   cart_quantity_change  - cart line minus / plus buttons, or a typed quantity
//   cart_upsell_add       - '+' on a 'CUSTOMERS ALSO BOUGHT' card
//   cart_checkout_click   - black 'Proceed to Checkout' button
// Runs side by side with the older remove_from_cart / quantity_button_click / add_to_cart_upsell tags;
// it does not touch them.
// Strict no-op: each listener only acts on its own cart element; nothing on the page is changed. No
// customer data. Values come from what the cart itself prints (each line's own product data, the totals)
// and, once a change has landed, one read of the shop's own /cart.js (same-origin, read-only).

(function () {
  'use strict';

  if (window.__nkCartEventsInstalled) return;
  window.__nkCartEventsInstalled = true;

  var FLYOUT = '.custom-cart__flyout';

  function text(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function push(event, fields) {
    var payload = { event: event };
    for (var k in fields) if (Object.prototype.hasOwnProperty.call(fields, k)) payload[k] = fields[k];
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }
  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }
  function inCart(el) { return !!closest(el, FLYOUT); }
  function money(pence) { return Math.round(Number(pence) || 0) / 100; }
  function moneyText(el) {
    var m = text(el).replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
    return m ? Number(m[1]) : 0;
  }
  function deviceType() {
    return window.matchMedia && window.matchMedia('(min-width: 768px)').matches ? 'desktop' : 'mobile';
  }

  // ---- what the cart prints ----
  function cartCount() {
    var n = parseInt(text(document.querySelector(FLYOUT + ' .filled-cart-count, ' + FLYOUT + ' .cart-item-counts')), 10);
    return isNaN(n) ? 0 : n;
  }
  function cartTotal() {
    var el = document.querySelector(FLYOUT + ' .custom-cart__flyout-subtotal-final-amount');
    return el && cartCount() > 0 ? moneyText(el) : 0;
  }
  // Each cart line's bin link carries the shop's own product data (item_id = SKU, price, variant).
  function attrOf(el, prefix) {
    if (!el || !el.attributes) return '';
    for (var i = 0; i < el.attributes.length; i++) {
      var a = el.attributes[i];
      if (a.name.indexOf(prefix) === 0) return a.value || '';
    }
    return '';
  }
  function pick(src, re) { var m = src.match(re); return m ? m[1] : ''; }

  // ---- the shop's own cart, read once a change has landed ----
  // Polls /cart.js (GET, same origin) until `check(cart)` is true or ~5 s pass, then hands over the
  // last cart read (or null). Always calls back, so an event is never lost.
  function afterUpdate(check, then) {
    var tries = 0, last = null;
    (function poll() {
      setTimeout(function () {
        fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { last = c; })
          .catch(function () {})
          .then(function () {
            if ((last && check(last)) || ++tries >= 8) then(last);
            else poll();
          });
      }, tries ? 600 : 900);
    })();
  }
  function findVariant(cart, id) {
    var list = (cart && cart.items) || [];
    for (var i = 0; i < list.length; i++) if (String(list[i].variant_id || list[i].id) === String(id)) return list[i];
    return null;
  }
  function cartValue(cart) { return cart ? money(cart.total_price) : cartTotal(); }

  // ---- one cart line ----
  function lineOf(el) { return closest(el, '.custom-cart__flyout-item'); }
  function lineVariant(line) {
    var input = line && line.querySelector('input[name="quantity"][data-id]');
    if (input) return input.getAttribute('data-id');
    var a = line && line.querySelector('a[href*="variant="]');
    var m = a && a.getAttribute('href').match(/variant=(\d+)/);
    return m ? m[1] : '';
  }
  function lineQty(line) {
    var input = line && line.querySelector('input[name="quantity"]');
    var n = input ? parseInt(input.value, 10) : NaN;
    return isNaN(n) ? 0 : n;
  }
  function lineFacts(line) {
    var src = attrOf(line && line.querySelector('a.custom-cart__flyout-item-remove'), '@click');
    var vid = lineVariant(line);
    return {
      vid: vid,
      item_id: pick(src, /item_id:\s*"([^"]*)"/) || vid,
      item_name: text(line && line.querySelector('.custom-cart__flyout-item-product-title')) || pick(src, /item_name:\s*"([^"]*)"/),
      item_variant: text(line && line.querySelector('.custom-cart__flyout-item-variant-title')) || pick(src, /item_variant:\s*"([^"]*)"/),
      price: Number(pick(src, /price:\s*parseFloat\("([\d.]+)"\)/)) || 0
    };
  }
  function lineSkus() {
    var out = [], lines = document.querySelectorAll(FLYOUT + ' .custom-cart__flyout-item');
    for (var i = 0; i < lines.length; i++) { var f = lineFacts(lines[i]); if (f.item_id) out.push(f.item_id); }
    return out;
  }

  // ---- clicks (capture phase, so the shop's own handlers cannot hide them) ----
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!inCart(t)) return;

    if (closest(t, 'button[aria-label="Close Cart"]')) {
      push('cart_close', {
        location_id: 'cart', cart_item_count: cartCount(), cart_value: cartTotal(), device_type: deviceType()
      });
      return;
    }

    var remove = closest(t, 'a.custom-cart__flyout-item-remove');
    if (remove) {
      var rl = lineOf(remove);
      var r = lineFacts(rl);
      var rq = lineQty(rl) || 1;
      removed(r, rq);
      return;
    }

    var qbtn = closest(t, 'button.custom-cart__flyout-item-quantity-widget-button');
    if (qbtn) {
      var ql = lineOf(qbtn);
      var q = lineFacts(ql);
      var before = lineQty(ql);
      var plus = text(qbtn) === '+';
      var after = plus ? before + 1 : Math.max(0, before - 1);
      if (after === 0 && before > 0) removed(q, before);
      quantityChange(q, plus ? 'plus' : 'minus', before, after);
      return;
    }

    var cta = closest(t, 'button.cart-ai-reco-product_cta');
    if (cta) {
      var card = closest(cta, '.cart-ai-reco__product-item');
      var uvid = pick(attrOf(cta, '@click') || attrOf(cta, 'x-on:click'), /id:\s*(\d+)/);
      var name = text(card && card.querySelector('.cart-ai-reco__product-title, h3'));
      var price = moneyText(card && card.querySelector('.cart-ai-reco__product-price'));
      var index = 0;
      if (card && card.parentElement) {
        var cards = card.parentElement.querySelectorAll('.cart-ai-reco__product-item');
        for (var i = 0, n = 0; i < cards.length; i++) {
          if (cards[i].classList.contains('hidden')) continue;
          n++;
          if (cards[i] === card) { index = n; break; }
        }
      }
      afterUpdate(function (c) { return !!findVariant(c, uvid); }, function (c) {
        var it = findVariant(c, uvid);
        push('cart_upsell_add', {
          location_id: 'cart_upsell', item_list_id: 'customers_also_bought', item_list_name: 'Customers Also Bought',
          item_id: (it && it.sku) || uvid, item_name: (it && it.product_title) || name,
          price: price || (it ? money(it.final_price != null ? it.final_price : it.price) : 0), index: index
        });
      });
      return;
    }

    if (closest(t, 'a.custom-cart__checkout-button')) {
      push('cart_checkout_click', {
        location_id: 'cart', currency: 'GBP', value: cartTotal(),
        savings: moneyText(document.querySelector(FLYOUT + ' .custom-cart__flyout-saving-amount')),
        cart_item_count: cartCount(), items: lineSkus().join(', ')
      });
    }
  }, true);

  // A line leaves the basket (bin, minus to 0 or typed 0): reported at the tap, like the shop's own
  // remove_from_cart, so a shopper who leaves the page straight away is still counted.
  function removed(f, qty) {
    var lineValue = Math.round(f.price * qty * 100) / 100;
    // The same removal also carries GA4's standard ecommerce block, so the GTM tag
    // 'GA4 - remove_from_cart (standard) - Nikura' can send GA4's built-in remove_from_cart.
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    push('cart_remove_item', {
      location_id: 'cart', currency: 'GBP', value: lineValue,
      item_id: f.item_id, item_name: f.item_name, item_variant: f.item_variant,
      quantity: qty, price: f.price, cart_value_after: Math.max(0, Math.round((cartTotal() - lineValue) * 100) / 100),
      ecommerce: { currency: 'GBP', value: lineValue, items: [{
        item_id: f.item_id, item_name: f.item_name, item_variant: f.item_variant, price: f.price, quantity: qty }] }
    });
  }

  function quantityChange(f, button, before, after) {
    afterUpdate(function (c) {
      var it = findVariant(c, f.vid);
      return after === 0 ? !it : !!(it && Number(it.quantity) === after);
    }, function (c) {
      push('cart_quantity_change', {
        location_id: 'cart', button: button, item_id: f.item_id, item_name: f.item_name,
        quantity_before: before, quantity_after: after, cart_value_after: cartValue(c)
      });
    });
  }

  // ---- typed quantity: remember the number on focus, report once when the typing is finished ----
  document.addEventListener('focusin', function (e) {
    var input = e.target;
    if (!input || input.name !== 'quantity' || !inCart(input)) return;
    input.__nkQtyBefore = lineQty(lineOf(input));
  }, true);
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.name !== 'quantity' || !inCart(input)) return;
    var line = lineOf(input);
    var before = typeof input.__nkQtyBefore === 'number' ? input.__nkQtyBefore : NaN;
    var after = lineQty(line);
    input.__nkQtyBefore = after;
    if (isNaN(before) || before === after) return;
    var f = lineFacts(line);
    if (after === 0 && before > 0) removed(f, before);
    quantityChange(f, 'typed', before, after);
  }, true);
})();
// Nikura Custom Code - Cart (basket pop-out) events - End
